<template>
  <div class="new_vip">
    <div class="content">
      <div class="button_line">
        <el-form :inline="true" :model="params" class="demo-form-inline">
          <el-form-item label="未消费几天的客户">
            <el-input
              v-model="params.days"
              placeholder="天数"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="天数"> </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getData" size="small"
              >查询</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button size="small" @click="sendCouponFrom()"
              >发送优惠券</el-button
            >
          </el-form-item>
          <el-form-item>
            <div class="button_right">
              <el-popover placement="bottom" width="120" trigger="click">
                <el-checkbox
                  style="margin-bottom:10px"
                  v-for="(item, index) in showTableItems"
                  :key="index"
                  v-model="item.show"
                  >{{ item.name }}</el-checkbox
                >
                <el-button
                  slot="reference"
                  size="small"
                  icon="el-icon-s-unfold"
                ></el-button>
              </el-popover>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="table_content">
        <el-table
          ref="multipleTable"
          :data="tableData"
          v-loading="tableLoading"
          element-loading-text="正在查询..."
          @sort-change="sortData"
          select-on-indeterminate
          @selection-change="handleSelectionChange"
          border
          height="100%"
        >
          <el-table-column type="selection" width="63"></el-table-column>
          <el-table-column
            label="卡号"
            prop="card_num"
            v-if="showTableItems[0].show"
          ></el-table-column>
          <el-table-column
            label="等级"
            prop="level_name"
            v-if="showTableItems[2].show"
          ></el-table-column>
          <el-table-column label="头像" v-if="showTableItems[3].show">
            <template slot-scope="scope">
              <div class="headimg">
                <img :src="scope.row.headimgurl" alt="" />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="性别"
            prop="show_sex"
            v-if="showTableItems[4].show"
          ></el-table-column>
          <el-table-column
            label="手机"
            prop="mobile"
            v-if="showTableItems[5].show"
            min-width="106px"
          >
            <template slot-scope="scope">
              <div>
                <el-button type="text" @click="rowClick(scope.row.id)">{{
                  scope.row.mobile
                }}</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="最后支付时间"
            prop="payment_time"
            v-if="showTableItems[6].show"
          ></el-table-column>
          <el-table-column
            label="总消费金额"
            prop="total_custom"
            v-if="showTableItems[7].show"
          ></el-table-column>
          <!-- <el-table-column label="累计消费" prop="total_custom" v-if="showTableItems[8].show"></el-table-column>
          <el-table-column label="累计积分" prop="total_point" v-if="showTableItems[9].show"></el-table-column> -->
          <el-table-column
            label="剩余时间"
            prop="show_end_time"
            v-if="showTableItems[8].show"
          ></el-table-column>
        </el-table>
      </div>
      <div class="page">
        <el-pagination
          background
          layout="prev, pager, next, total"
          :current-page="page"
          :total="total"
          :page-size="10"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 发送优惠券弹窗 -->
    <el-dialog
      :visible.sync="showSendCoupon"
      title="发送优惠券"
      @close="closeSend"
      width="700px"
    >
      <!-- 选择发布方式 -->
      <div>
        <div class="" style="text-align:center">
          <span>发送方式：</span>
          <el-radio v-model="CouponType" label="1">多券发布</el-radio>
          <el-radio v-model="CouponType" label="2">单券多张</el-radio>
        </div>
      </div>
      <!-- 多卷发布 -->
      <div class="single" v-if="CouponType == '1'">
        <el-form label-width="90px" size="">
          <el-form-item label="发送给" style="margin-bottom:0">
            {{ sendCouponUserName }}
            <!-- {{selectUserName}}
            <el-button size="small" @click="showSelecterUser=true" :disabled="sendToAll">选择</el-button> -->
            <div>
              <el-checkbox v-model="sendToAll">全部用户</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item label="优惠券">
            <el-tag
              v-for="(tag, idx) in sList"
              :key="tag.id"
              closable
              @close="delTagItem(idx)"
              style="margin-bottom:5px;margin-right:5px;"
            >
              {{ tag.name }}
            </el-tag>
            <el-button size="small" @click="showSelecter = true"
              >选择</el-button
            >
          </el-form-item>
          <el-form-item
            label="验证码"
            v-if="sms_stats.open_sms_coupon == 1"
            style="width:386px"
          >
            <el-input class="input_box" v-model="code_num">
              <template slot="append">
                <el-link
                  :disabled="btn_status"
                  @click="getCode"
                  type="primary"
                  >{{ code_text }}</el-link
                >
              </template>
            </el-input>
          </el-form-item>
        </el-form>
        <div style="text-align:center">
          <el-button type="primary" @click="clickSend()">发送</el-button>
          <el-button @click="closeSend()">取消</el-button>
        </div>
      </div>
      <!-- 单卷多张 -->
      <div class="single" v-if="CouponType == '2'">
        <el-form label-width="90px" size="">
          <el-form-item label="发送给" style="margin-bottom:0">
            {{ sendCouponUserName }}
            <!-- {{selectUserName}} -->
            <!-- <el-button size="small" @click="showSelecterUser=true" :disabled="sendToAll">选择</el-button> -->
            <div>
              <el-checkbox v-model="sendToAll">全部用户</el-checkbox>
            </div>
          </el-form-item>
          <el-form-item label="优惠券" style="margin-bottom:5px">
            <el-tag
              v-if="couponOne.id != ''"
              :key="couponOne.id"
              style="margin-bottom:5px;margin-right:5px;"
            >
              {{ couponOne.name }}
            </el-tag>
            <el-button size="small" @click="showSelecterOne = true"
              >选择</el-button
            >
          </el-form-item>
          <el-form-item label="每人送" style="margin-bottom:5px">
            <el-input
              v-model="everyoneNum"
              placeholder=""
              size="small"
              style="width:100px;margin-right:5px;"
            ></el-input
            >张
          </el-form-item>
          <el-form-item
            label="验证码"
            v-if="sms_stats.open_sms_coupon == 1"
            style="width:386px"
          >
            <el-input class="input_box" v-model="code_num">
              <template slot="append">
                <el-link
                  :disabled="btn_status"
                  @click="getCode"
                  type="primary"
                  >{{ code_text }}</el-link
                >
              </template>
            </el-input>
          </el-form-item>
          <!-- <el-form-item label="">
            <el-checkbox v-model="timingSend">定时发送</el-checkbox>
          </el-form-item> -->
        </el-form>
        <div style="text-align:center">
          <el-button type="primary" @click="clickSend()">发送</el-button>
          <el-button @click="closeSend()">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 选择用户弹窗 -->
    <el-dialog
      :visible.sync="showSelecterUser"
      @close="showSelecterUser = false"
    >
      <selectCommodity
        @close="showSelecterUser = false"
        @getCommod="getCommodUser"
        :sList="sUserList"
        :jude="4"
        :menuName="'会员'"
      ></selectCommodity>
    </el-dialog>
    <!-- 选择优惠券弹窗 -->
    <!-- 多张优惠券发送1张 -->
    <el-dialog :visible.sync="showSelecter" @close="showSelecter = false">
      <selectCommodity
        @close="showSelecter = false"
        @getCommod="getCommod"
        :sList="sList"
        :jude="2"
        :menuName="'优惠券'"
      ></selectCommodity>
    </el-dialog>
    <!-- 单张优惠券发送多张 -->
    <el-dialog
      :visible.sync="showSelecterOne"
      @close="showSelecterOne = false"
      width="460px"
    >
      <selectCommodityOne
        @close="showSelecterOne = false"
        @getCommod="getCommodOne"
        :jude="2"
      ></selectCommodityOne>
    </el-dialog>
    <!-- 单券多张发送进度 -->
    <el-dialog
      :visible.sync="showSendPro"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      title="发送优惠券"
      center
    >
      <div style="text-align:center">
        <div style="margin-bottom:20px">
          <el-progress type="circle" :percentage="sentPercent"></el-progress>
        </div>
        <div>
          <i class="el-icon-loading"></i> 正在发送优惠券，请勿关闭网页。
        </div>
      </div>
    </el-dialog>
    <!-- 修改用户信息 -->
    <el-dialog
      :visible.sync="showEditUser"
      @close="showEditUser = false"
      width="70%"
      title="修改会员信息"
    >
      <user-edit
        :type="'edit'"
        :editData="editData"
        @close="showEditUser = false"
        @refresh="getData()"
      ></user-edit>
    </el-dialog>
    <!-- 添加会员标签 -->
    <el-dialog
      :visible.sync="showUserTag"
      title="添加会员标签"
      @close="closeTag(0)"
      width="400px"
    >
      <user-tag :uid="selectUid" @closeTag="closeTag"></user-tag>
    </el-dialog>
  </div>
</template>

<script>
import selectCommodity from "@/components/commodity/selectCommodity.vue";
import selectCommodityOne from "@/components/commodity/selectCommodity2.vue";
import { mapGetters } from "vuex";
import { SendAdminCode } from "@/api/set";
import {
  changeUserLevel,
  employeeOptions,
  levelGroupSelect,
  userCallbackList,
  userCallbackMoreTicket,
  userCallbackSingleTicket
} from "@/api/vip";
import { storeSelect } from "@/api/employee";
import UserAccount from "@/views/apply/vip/vipUserAccount";
import OrderList from "@/views/apply/newVip/order/oilsList";
import VoucherList from "@/views/apply/newVip/order/voucherList";
import UserEdit from "@/views/apply/newVip/home/openCard";
import UserTag from "@/components/vip/userTags";

export default {
  components: {
    UserAccount,
    selectCommodity,
    OrderList,
    VoucherList,
    selectCommodityOne,
    UserEdit,
    UserTag
  },
  computed: {
    ...mapGetters(["token", "app_id", "status"])
  },
  data() {
    return {
      code_num: "",
      code_text: "获取验证码",
      btn_status: false,
      timer: null,
      sms_stats: {},
      keyword: "", //会员手机号
      params: {
        //查询条件
        days: "", //天数
        name: "", //会员姓名
        card_num: "", //会员卡号
        user_level_id: "", //会员等级id
        mobile: "" //手机号
      },
      store_options: [], //店铺选项
      level_options: [], //会员等级选项
      emp_options: [], //员工选项
      tableData: [], //表格数据
      multipleSelection: [], //表格选中项
      showTableItems: [
        { name: "卡号", show: true },
        { name: "姓名", show: true },
        { name: "等级", show: true },
        { name: "头像", show: true },
        { name: "性别", show: true },
        { name: "手机", show: true },
        { name: "最后支付时间", show: true },
        { name: "总消费金额", show: true },
        { name: "剩余时间", show: true }
        // {name: "消费记录",show: true},
      ], //表格显示内容
      page: 1, //页码
      total: 0, //总数
      showSearchBox: false, //显示高级查询窗口
      searchForm: {}, //高级查询表单
      showAccount: false, //显示修改账户弹窗
      accountData: {}, //用户账户信息
      accountTabs: "point", //充值类型 point:积分 balance:余额
      showSum: false, //显示统计行
      showCarDetail: false, //显示车辆信息
      carDetail: {}, //车辆信息
      showInvoiceDetail: false, //显示开票信息
      InvoiceDetail: {}, //开票信息
      sort: "0", //'0':正常，'1':按积分从大到小排序
      showSendCoupon: false, //显示发送优惠券弹窗
      sendCouponUserName: "", // 发送优惠券的用户名
      showSelecter: false, // 选择优惠券弹窗
      showSelecterOne: false, // 选择优惠券弹窗 单张
      couponOne: { id: "" }, //单张优惠券信息
      sList: [], //已选择优惠券列表
      showChangeLevel: false, //会员调级窗口
      change_level_id: "", //调整等级id
      showOrderList: false, //用户油品订单
      user_id_order: "", //查看订单用户id
      user_id_voucher: "", //查看充值用户id
      showVoucherList: false, //用户充值订单
      CouponType: "0", // 优惠券发布类型
      everyoneNum: "", //单券多张 张数
      timingSend: false, // 定时发送
      tableLoading: false, //表格loading
      selectUserName: "", //选择的用户名称
      showSelecterUser: false, //选择用户弹窗
      sUserList: [], //已选择用户
      sendToAll: false, //发送给全部用户
      showSendPro: false, //单券多张发送窗口
      sentPercent: 0, //单券多张发送进度
      showEditUser: false, //修改用户信息弹窗
      editData: {}, //修改会员表单信息
      statItems: {
        cards: []
      }, //统计项
      showUserTag: false, // 用户标签弹窗
      selectUid: "" // 选择的用户uid
    };
  },
  mounted() {
    // this.init();
    this.getData();
    this.get_prosms_ob().then(res=>{
      console.log('22',res)
      this.sms_stats = res
    })
  },
  methods: {
    // 获取数据
    getData() {
      this.tableLoading = true;
      var data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page
      };
      if (this.params.days != "") {
        data.days = this.params.days;
      }
      userCallbackList(data).then(res => {
        console.log("要找回客户列表", res);
        this.tableData = res.data;
        // this.statItems = Object.assign({},res.data.count);
        // this.statItems.balance = res.data.count.balance;
        // this.statItems.point = res.data.count.point;
        // this.statItems.cards = res.data.count_oil;
        // var a = Number(this.statItems.balance);
        // console.log(this.statItems.cards.length);
        // if (this.statItems.cards.length) {
        //   this.statItems.cards.forEach(item => {
        //     a += Number(item.count.balance);
        //   });
        //   this.statItems.cardAll = a.toFixed(2);
        // }
        this.tableData.forEach(item => {
          item.show_sex = item.sex == 1 ? "男" : item.sex == 2 ? "女" : "未知";
          // item.show_end_time = item.up_time == 0? "永久有效":"剩余"+item.up_time+"天"
          item.show_end_time = "永久有效";
        });
        this.total = res.total;
        this.showSum = this.tableData.length ? true : false;
        this.tableLoading = false;
      });
    },
    // 初始化选择项
    init() {
      var data = {
        token: this.token,
        app_id: this.app_id
      };
      if (this.$route.query.user_level) {
        this.searchForm.user_level_id = this.$route.query.user_level;
        this.search();
      }
      storeSelect(data).then(res => {
        if (res.code == 200) {
          this.store_options = res.data;
        } else {
          // this.$message({
          //   type: "error",
          //   message: "获取门店列表失败，请刷新重试"
          // })
        }
      });
      levelGroupSelect(data).then(res => {
        if (res.code == 200) {
          this.level_options = res.data;
        } else {
        }
      });
      employeeOptions(data).then(res => {
        if (res.code == 200) {
          this.emp_options = res.data;
        } else {
          // this.$message({
          //   type: "error",
          //   message: "获取员工列表失败，请刷新重试"
          // })
        }
      });
    },
    getCode() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.SendMyCode();
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
            this.code_text = this.count + "s";
            this.btn_status = true;
          } else {
            this.btn_status = false;
            this.timer = null;
            this.code_text = "获取验证码";
          }
        }, 1000);
      }
    },
    // 管理员发送验证码
    async SendMyCode() {
      try {
        var data = { app_id: this.app_id };
        const res = await SendAdminCode(data);
        if (res.code == 200) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 高级查询
    search() {
      console.log(this.searchForm);
      this.params.card_num = this.searchForm.card_num;
      this.params.user_level_id = this.searchForm.user_level_id;
      this.params.name = this.searchForm.name;
      this.showSearchBox = false;
      this.page = 1;
      this.getData();
    },
    // 表格多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(val);
      this.sendCouponUserName =
        this.multipleSelection.map(n => n.real_name).join(",") +
        " 共" +
        this.multipleSelection.length +
        "位用户";
    },
    // 分页
    handleCurrentChange(val) {
      console.log(val);
      this.page = val;
      this.getData();
    },
    // 会员修改
    editItems() {
      return false;
      if (this.multipleSelection.length != 1) {
        this.$message("请选择一个用户操作");
      } else {
        var data = this.multipleSelection[0];
        this.editData = {
          real_name: data.real_name,
          sex: data.sex,
          mobile: data.mobile,
          level_card_id: data.user_level_id,
          birthday: data.birthday,
          id: data.uid
        };
        this.showEditUser = true;
      }
    },
    // 会员删除
    delItems() {
      var i = this.multipleSelection.map(x => x.id).join(",");
      console.log(i);
      var title;
      this.$confirm("删除后无法恢复！确定删除？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          var data = {
            token: this.token,
            app_id: this.app_id,
            id: i
          };
          // delList(data).then(res => {
          //   if (res.code == 200) {
          //     this.$message({
          //       type: "success",
          //       message: "删除成功"
          //     });
          //     this.getData();
          //   } else {
          //     this.$message({
          //       type: "error",
          //       message: res.msg
          //     });
          //   }
          // });
        })
        .catch();
    },
    // 会员充值 type: 1.余额，2.积分
    editAccount(type) {
      if (this.multipleSelection.length != 1) {
        this.$message("请选择一个用户操作");
      } else {
        this.accountData = {
          uid: this.multipleSelection[0].uid,
          balance: this.multipleSelection[0].balance,
          point: this.multipleSelection[0].point,
          card_id: this.multipleSelection[0].id
        };
        this.accountTabs = type == 1 ? "balance" : "point";
        this.showAccount = true;
      }
    },
    // 自定义统计方法
    getSummaries(param) {
      console.log(param);
      if (param.data.length) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = "总计:";
            return;
          }
          if (
            column.label == "积分" ||
            (column.label == "余额" && data.length)
          ) {
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values
                .reduce((prev, curr) => {
                  const value = Number(curr);
                  if (!isNaN(value)) {
                    return prev + curr;
                  } else {
                    return prev;
                  }
                }, 0)
                .toFixed(2);
            }
          }
        });
        return sums;
      }
    },
    // 会员导入
    gotoImport() {
      this.$router.push("/apply/newVip/13/center/import");
    },
    // 查看车辆信息
    showCarMsg(id) {
      console.log(id);
      this.showCarDetail = true;
      var data = {
        token: this.token,
        app_id: this.app_id,
        id: id
      };
      // vipCarMsg(data).then(res => {
      //   if(res.code == 200){
      //     this.carDetail = res.data
      //   }else{
      //     this.$message(res.msg)
      //   }
      // })
    },
    // 关闭车辆信息
    closeCarDetail() {
      this.showCarDetail = false;
      this.carDetail = {};
    },
    // 查看开票信息
    showInvoiceMsg(id) {
      console.log(id);
      this.showInvoiceDetail = true;
      var data = {
        token: this.token,
        app_id: this.app_id,
        id: id
      };
      // vipInvoiceMsg(data).then(res => {
      //   if(res.code == 200){
      //     this.invoiceDetail = res.data
      //   }else{
      //     this.$message(res.msg)
      //   }
      // })
    },
    // 关闭开票信息
    closeInvoiceDetail() {
      this.showInvoiceDetail = false;
      this.InvoiceDetail = {};
    },
    //自定义排序
    sortData(event) {
      console.log(event);
      if (event.order == "descending") {
        this.sort = "1";
        this.page = 1;
        this.getData();
      } else if (event.order == null) {
        this.sort = "0";
        this.page = 1;
        this.getData();
      }
    },
    // 点击行跳转用户详情
    rowClick(id) {
      console.log("userInfor 不存在");
      // this.$router.push({
      //   path: "/apply/newVip/13/center/userDetail",
      //   query: { id: id }
      // });
    },
    // 发送优惠券弹窗
    sendCouponFrom() {
      if (this.multipleSelection.length == 0) {
        this.$message("至少选择一个用户操作");
      } else {
        this.showSendCoupon = true;
      }
      // this.showSendCoupon = true;
    },
    getCommodUser(data) {
      console.log(data);
      this.sUserList = data;
      if (data.length > 5) {
        this.selectUserName =
          data[0].name +
          "," +
          data[1].name +
          "," +
          data[2].name +
          "," +
          data[3].name +
          "," +
          data[4].name +
          "等" +
          data.length +
          "位用户";
      } else {
        this.selectUserName =
          data.map(n => n.name).join(",") + " 共" + data.length + "位用户";
      }
      this.showSelecterUser = false;
    },
    //选择优惠券 单张
    getCommodOne(data) {
      console.log(data);
      this.couponOne = data;
      this.showSelecterOne = false;
    }, //选择优惠券
    getCommod(data) {
      console.log(data);
      this.sList = data;
      this.showSelecter = false;
    },
    //删除已选择优惠券
    delTagItem(i) {
      this.sList.splice(i, 1);
    },
    //发送
    clickSend() {
      var data = {
        token: this.token,
        app_id: this.app_id,
        verification_code: this.code_num
      };
      if (this.params.days != "") {
        data.days = this.params.days;
      }
      // data.uid = this.sUserList.map(item => item.id).join(',');
      data.uid = this.multipleSelection.map(item => item.id).join(",");

      if (this.sendToAll) {
        data.all = 1;
      } else {
        data.all = 0;
      }
      // 1 多 2 单
      if (this.CouponType == "1") {
        data.id = this.sList.map(i => i.id).join(",");
        console.log(data);
        this.startSendCoupon2(data);
      } else {
        data.coupon_id = this.couponOne.id;
        data.num = this.everyoneNum;
        this.startSendCoupon(data);
      }
      this.sentPercent = 0;
      this.showSendPro = true;
    },
    startSendCoupon(data) {
      console.log("参数", data);
      var nextData = Object.assign({}, data);
      userCallbackSingleTicket(data).then(res => {
        if (res.code == 300) {
          //部分完成
          nextData.batch = res.batch;
          this.sentPercent = (Number(res.percent) * 100).toFixed(0);
          this.startSendCoupon(nextData);
        } else if (res.code == 200) {
          this.sentPercent = 100;
          this.$message({
            type: "success",
            message: "发送完成"
          });
          setTimeout(() => {
            this.showSendPro = false;
            this.showSendCoupon = false;
            this.sendToAll = false;
          }, 300);
        } else {
          this.$message(res.msg);
          setTimeout(() => {
            this.showSendPro = false;
          }, 300);
        }
      });
    },
    startSendCoupon2(data) {
      console.log("参数", data);
      var nextData = Object.assign({}, data);
      userCallbackMoreTicket(data).then(res => {
        if (res.code == 300) {
          //部分完成
          this.sentPercent = (Number(res.percent) * 100).toFixed(0);
          this.startSendCoupon2(nextData);
        } else if (res.code == 200) {
          this.sentPercent = 100;
          this.$message({
            type: "success",
            message: "发送完成"
          });
          setTimeout(() => {
            this.showSendPro = false;
            this.showSendCoupon = false;
            this.sendToAll = false;
          }, 300);
        } else {
          this.$message(res.msg);
          setTimeout(() => {
            this.showSendPro = false;
          }, 300);
        }
      });
    },
    //关闭发送优惠券窗口
    closeSend() {
      this.sList = [];
      this.sUserList = [];
      this.selectUserName = "";
      this.showSendCoupon = false;
      this.sendToAll = false;
      this.CouponType = "0";
    },
    // 打开调级窗口
    openChangeLevel() {
      if (this.multipleSelection.length == 0) {
        this.$message("至少选择一个用户操作");
      } else {
        this.showChangeLevel = true;
      }
    },
    // 调级保存
    clickChangeLevel() {
      var data = {
        token: this.token,
        app_id: this.app_id,
        user_level_id: this.change_level_id
      };
      data.uids = this.multipleSelection.map(item => item.uid).join(",");
      console.log(data);
      // return false;
      changeUserLevel(data).then(res => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "修改成功"
          });
          this.closeChange();
          this.getData();
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      });
    },
    // 关闭调级弹窗
    closeChange() {
      this.change_level_id = "";
      this.showChangeLevel = false;
    },
    // 手机号查询
    searchMobile() {
      this.page = 1;
      this.getData();
    },
    // 用户油品订单
    showOrderMsg(id) {
      this.user_id_order = String(id);
      this.showOrderList = true;
    },
    // 用户充值订单
    showVoucherMsg(id) {
      this.user_id_voucher = id;
      this.showVoucherList = true;
    },
    // 导出
    exportList() {
      var param =
        "?token=" +
        this.token +
        "&app_id=" +
        this.app_id +
        "&point_order=" +
        this.sort +
        "&export_=1";
      if (this.params.mobile != "") {
        param += "&mobile=" + this.params.mobile;
      }
      if (this.params.name != "") {
        param += "&name=" + this.params.name;
      }
      if (this.params.card_num != "") {
        param += "&card_num=" + this.params.card_num;
      }
      if (this.params.user_level_id != "") {
        param += "&user_level_id=" + this.params.user_level_id;
      }

      var url1 =
        "https://www.58zltc.com/user/agent.User_level_card/index" + param;
      if (this.status == "test") {
        url1 = "https://cs.58zltc.com/user/agent.User_level_card/index" + param;
      }
      console.log(url1);
      // return false;
      window.location.href = url1;
      // let myObj = {
      //   method: 'get',
      //   url: url1,
      //   fileName: '会员列表',
      // }
      // exportMethod(myObj)
    },
    // 添加会员标签
    setUserTag() {
      this.selectUid = this.multipleSelection.map(x => x.uid).join(",");
      console.log(this.selectUid);
      this.showUserTag = true;
    },
    closeTag(i) {
      this.showUserTag = false;
      if (i == 1) {
        this.getData();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.new_vip {
  padding: 15px;
  height: 100%;
  background: #f1f2f6;
  .content {
    background: #fff;
    padding: 5px 20px;
    height: 100%;
    display: flex;
    flex-direction: column;

    .button_line {
      height: 135px;
      display: flex;
      align-items: center;
      .button_left {
        flex: 1;
      }
      .button_right {
        margin-left: 10px;
      }
    }
    .table_content {
      flex: 1;
      .headimg {
        width: 36px;
        height: 36px;
        img {
          width: 36x;
          height: 36px;
          border-radius: 18px;
        }
      }
    }
    .page {
      height: 30px;
      margin-top: 15px;
      text-align: right;
    }
  }
  .search_form_item {
    display: inline-block;
    width: 50%;
    .search_input {
      width: 214px;
    }
  }
  .search_button {
    margin-top: 15px;
    text-align: center;
  }
  .get-code {
    cursor: pointer;
  }
  .car_msg_box {
    display: flex;
    flex-wrap: wrap;
    .car_msg_item {
      width: 50%;
      line-height: 40px;
    }
  }
}
</style>
